import { render, staticRenderFns } from "./Odometer.vue?vue&type=template&id=2f8ce649&scoped=true&"
import script from "./Odometer.vue?vue&type=script&lang=ts&"
export * from "./Odometer.vue?vue&type=script&lang=ts&"
import style0 from "./Odometer.vue?vue&type=style&index=0&id=2f8ce649&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8ce649",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout,VSpacer})
